<template>
  <v-data-table
    :sort-by.sync="sortBy"
    :sort-desc.sync="sortDesc"
    :page.sync="page"
    :items-per-page.sync="itemsPerPage"
    :group-by.sync="groupBy"
    :group-desc.sync="groupDesc"
    :multi-sort.sync="multiSort"
    :must-sort.sync="mustSort"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template
      v-for="(_, slot) of $scopedSlots"
      #[slot]="scope"
    >
      <slot
        :name="slot"
        v-bind="scope"
      />
    </template>
  </v-data-table>
</template>

<script>
import isUndefined from 'lodash/isUndefined'
import isArray from 'lodash/isArray'
import debounce from 'lodash/debounce'
import isEqual from 'lodash/isEqual'

const toBoolean = (value) => value === 'true'
const toString = (value) => value.toString()
const fromBoolean = (value) => (value ? 'true' : 'false')

const toArray = (transform) => (value) =>
  (isArray(value) ? value : [value]).map(transform)

const toStringArray = toArray(toString)
const toBooleanArray = toArray(toBoolean)

const fromBooleanArray = toArray(fromBoolean)

const identity = (value) => value

const number = { fromQuery: parseInt, toQuery: identity }
const boolean = { fromQuery: toBoolean, toQuery: fromBoolean }
const stringArray = { fromQuery: toStringArray, toQuery: identity }
const booleanArray = { fromQuery: toBooleanArray, toQuery: fromBooleanArray }

const QUERY_PARAMS = {
  page: number,
  itemsPerPage: number,
  sortBy: stringArray,
  sortDesc: booleanArray,
  groupBy: stringArray,
  groupDesc: booleanArray,
  multiSort: boolean,
  mustSort: boolean
}

const WATCHERS = Object.fromEntries(
  Object.entries(QUERY_PARAMS).map(([name, { toQuery }]) => {
    return [
      name,
      function (newVal) {
        this.query[name] = toQuery(newVal)
        if (!this.mounting) {
          this.updateRoute(name)
        }
      }
    ]
  })
)

export default {
  name: 'UrlPersistedDataTable',
  props: {
    defaultSortBy: {
      type: [Array, String],
      default: null
    },
    defaultSortDesc: {
      type: [Array, Boolean],
      default: null
    }
  },
  data: function () {
    return {
      page: 1,
      itemsPerPage: 10,
      sortBy: undefined,
      sortDesc: undefined,
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: false,
      query: null
    }
  },
  computed: {},
  watch: WATCHERS,
  beforeMount() {
    this.mounting = true
    const query = this.$route.query
    let hasChanges = false
    Object.entries(QUERY_PARAMS).forEach(([param, { fromQuery }]) => {
      const value = query[param]
      if (!isUndefined(value)) {
        this[param] = fromQuery(value)
      }
    })
    if (isUndefined(this.sortBy) && this.$props.defaultSortBy) {
      this.sortBy = toStringArray(this.$props.defaultSortBy)
      hasChanges = true
    }
    if (isUndefined(this.sortDesc) && this.$props.defaultSortDesc) {
      this.sortDesc = toBooleanArray(this.$props.defaultSortDesc)
      hasChanges = true
    }
    this.query = Object.assign({}, query)
    this.$nextTick(() => {
      this.mounting = false
      if (hasChanges) {
        this.replaceRoute()
      }
    })
  },
  methods: {
    replaceRoute() {
      this.$router.replace({ query: this.query }).catch(() => {})
    },
    updateRoute: debounce(function (trigger) {
      if (!isEqual(this.$route.query, this.query)) {
        this.$router.push({ query: this.query }).catch(() => {})
      }
    }, 10)
  }
}
</script>
